// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"d20ef7dd","453":"90001cf6","659":"e6454234","766":"d0846231"}[chunkId] + ".chunk.js";
};